import React, { useEffect, useState } from "react";
import { cargarPrecalificaciones } from "../../utils/Datos";
import { ModalDocumento } from "../Otros/ModalDocumento";
import { PlaceholderTabla } from "../Otros/Placeholder";

export const VerEvaluacionesPrecalificacionesFuncionario = ({
  id_participant,
  setPuedeRatificar = null,
}) => {
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [datos, setDatos] = useState(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    setCargandoDatos(true);
    cargarPrecalificaciones(id_participant).then((datos) => {
      setDatos(datos);
      setCargandoDatos(false);
      if (setPuedeRatificar != null) {
        setPuedeRatificar(
          datos.filter((dato) => dato.statusValidationFun).length > 0
        );
      }
    });
  }, []);

  const handleClick = () => {};

  return cargandoDatos || datos == null ? (
    <PlaceholderTabla></PlaceholderTabla>
  ) : (
    <>
      <table className="table table-rounded table-striped border gy-7 gs-7 ">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200 ">
            <th></th>
            <th>Etapa</th>
            <th>SF11</th>
            <th>SF12</th>
            <th>NOTA</th>
            <th>PSJ3F1</th>
            <th>SF21</th>
            <th>SF22</th>
            <th>SF23</th>
            <th>NOTA</th>
            <th>SFF2</th>
            <th>SF31</th>
            <th>SF32</th>
            <th>NOTA</th>
            <th>PSJF3</th>
            <th>FINAL</th>
            <th>LISTA</th>
            <th>DOCUMENTO</th>
          </tr>
        </thead>
        <tbody>
          {datos.length <= 0 ? (
            <tr>
              <td colSpan={17}>
                No hay precalificaciones/calificacines para mostrar
              </td>
            </tr>
          ) : (
            datos.map((d) => (
              <tr key={d.name}>
                <td>{d.statusValidationFun ? "Validada" : "No Validada"}</td>
                <td>{d.name}</td>
                <td>{d.subFactor11}</td>
                <td>{d.subFactor12}</td>
                <td>{d.qualificationFactor1}</td>
                <td>{d.scoreFactor1}</td>
                <td>{d.subFactor12}</td>
                <td>{d.subFactor22}</td>
                <td>{d.subFactor23}</td>
                <td>{d.qualificationFactor2}</td>
                <td>{d.scoreFactor2}</td>
                <td>{d.subFactor31}</td>
                <td>{d.subFactor32}</td>
                <td>{d.qualificationFactor3}</td>
                <td>{d.scoreFactor3}</td>
                <td>
                  <strong>{d.scoreFinal}</strong>
                </td>
                <td>{d.list}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark "
                    data-bs-toggle="modal"
                    data-bs-target="#modalDocumento"
                    onClick={() => {
                      setFile(d.file.contentByte);
                    }}
                  >
                     ver
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <ModalDocumento id="modalDocumento" documentoByte={file} />

      
    </>
  );
};
